export function preloadImages(scene) {
  scene.load.image('bg-start-scene', 'assets/GameAssets/bg-start-scene.png');
  scene.load.image('mainBg', 'assets/GameAssets/mainBg.png');
  scene.load.image('graphBg', 'assets/GameAssets/graphBg.png');
  scene.load.image('graph', 'assets/GameAssets/graph.png');
  scene.load.image('cityBg', 'assets/GameAssets/cityBg.png');
  scene.load.image('building-mall', 'assets/GameAssets/building-mall.png');
  scene.load.image('building-house', 'assets/GameAssets/building-house.png');
  scene.load.image('building-cafe', 'assets/GameAssets/building-cafe.png');
  scene.load.image('building-hospital', 'assets/GameAssets/building-hospital.png');
  scene.load.image('building-hotel', 'assets/GameAssets/building-hotel.png');
  scene.load.image('building-supermarket', 'assets/GameAssets/building-supermarket.png');
  scene.load.image('greenRectangle', 'assets/GameAssets/greenRectangle.png');
  scene.load.image('mallCard', 'assets/GameAssets/mallCard.png');
  scene.load.image('houseCard', 'assets/GameAssets/houseCard.png');
  scene.load.image('cafeCard', 'assets/GameAssets/cafeCard.png');
  scene.load.image('hospitalCard', 'assets/GameAssets/hospitalCard.png');
  scene.load.image('hotelCard', 'assets/GameAssets/hotelCard.png');
  scene.load.image('supermarketCard', 'assets/GameAssets/supermarketCard.png');
  scene.load.image('hand', 'assets/GameAssets/hand.png');
  scene.load.image('character', 'assets/GameAssets/character.png');
  scene.load.image('hover_replayButton', 'assets/GameAssets/hover_replayButton.png');
  scene.load.image('overlay', 'assets/GameAssets/overlay.png');
  scene.load.image('top-overlay', 'assets/GameAssets/top-overlay.png');
  scene.load.image('playButton', 'assets/GameAssets/playButton.png');
  scene.load.image('replayButton', 'assets/GameAssets/replayButton.png');
}
